




























































































































































































import Vue, { PropType } from "vue";
import VaCard from "../molecules/VaCard.vue";
import { ReleaseNotes } from "@/models/releaseNotes";
import VaButton from "../atoms/VaButton.vue";
import { VDialog } from "vuetify/lib";
import FileUtil from "@/utils/fileUtil";

export default Vue.extend({
  name: "SoftwareVersionRow",
  components: { VaCard, VaButton, VDialog },
  data() {
    return {
      downloading: false,
      dialog: false,
      changelogText: "",
      changelogTitle: "",
    };
  },

  props: {
    icon: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    note1: {
      type: Object as PropType<ReleaseNotes | null>,
      required: false,
      default: null,
    },
    note2: {
      type: Object as PropType<ReleaseNotes | null>,
      required: false,
      default: null,
    },
  },
  methods: {
    // an entry carries storeUrl only when the app is also published on a store,
    // alongside the download it offers on its own
    storeBadge(os?: string): string | null {
      switch (os) {
        case "android":
          return require("@/assets/images/badges/android.svg");
        case "ios":
          return require("@/assets/images/badges/ios.svg");
        default:
          return null;
      }
    },
    storeName(os?: string): string {
      return os === "ios" ? "App Store" : "Google Play";
    },
    showNotes(note?: ReleaseNotes): void {
      if (!note) return;
      this.changelogText = note.releaseNotes;
      this.changelogTitle = note.title;
      this.dialog = true;
    },
    async download(url: string): Promise<void> {
      this.downloading = true;
      try {
        if (url !== "") FileUtil.download(url);
      } catch (e) {
        this.$notification.error(e);
      } finally {
        this.downloading = false;
      }
    },
  },
  computed: {},
});
